module.exports = __webpack_public_path__ + "95bf344197a084ea2861c96cbaca304c.MP3";